var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3356_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3357_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13397_",
    style: {
      fill: "#010101"
    },
    d: "M377.904,368.504c-5.178,0-9.368-4.19-9.368-9.368s4.19-9.368,9.368-9.368 c46.521,0,84.376-37.854,84.376-84.376s-37.854-84.376-84.376-84.376c-4.668,0-10.085-3.282-10.754-7.918 c-8.492-59.618-60.303-104.594-120.51-104.594c-67.201,0-121.88,54.679-121.88,121.88c0,5.258,0.446,10.834,1.418,17.557 c0.382,2.693-0.414,5.417-2.199,7.472c-2.087,2.422-6.102,3.473-9.209,3.075c-35.576,0.016-65.019,29.458-65.019,65.64 s29.442,65.624,65.624,65.624c5.178,0,9.368,4.19,9.368,9.368s-4.19,9.368-9.368,9.368C68.854,368.488,31,330.634,31,284.112 c0-43.51,33.091-79.421,75.406-83.898c-0.271-3.441-0.414-6.691-0.414-9.846c0-77.541,63.075-140.632,140.632-140.632 c66.835,0,124.7,48.003,137.732,112.926C438.892,166.502,481,211.112,481,265.36C481.032,322.237,434.781,368.504,377.904,368.504 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3358_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3359_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3360_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3364_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13394_",
    style: {
      fill: "#010101"
    },
    d: "M246.656,462.264c-56.861,0-103.128-46.267-103.128-103.128 s46.267-103.128,103.128-103.128s103.128,46.267,103.128,103.128S303.517,462.264,246.656,462.264z M246.656,274.76 c-46.521,0-84.376,37.854-84.376,84.376s37.854,84.376,84.376,84.376s84.376-37.854,84.376-84.376 S293.177,274.76,246.656,274.76z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3365_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13393_",
    style: {
      fill: "#010101"
    },
    d: "M246.656,424.76c-5.178,0-9.368-4.19-9.368-9.368V302.896 c0-5.178,4.19-9.368,9.368-9.368c5.178,0,9.368,4.19,9.368,9.368v112.496C256.04,420.57,251.834,424.76,246.656,424.76z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3366_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13392_",
    style: {
      fill: "#010101"
    },
    d: "M246.656,424.76c-2.406,0-4.796-0.908-6.628-2.74l-37.504-37.504 c-3.664-3.664-3.664-9.591,0-13.255c3.664-3.664,9.591-3.664,13.255,0l30.876,30.876l30.876-30.876 c3.664-3.664,9.591-3.664,13.255,0c3.664,3.664,3.664,9.591,0,13.255l-37.504,37.504 C251.451,423.852,249.062,424.76,246.656,424.76z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileDownload);
export default __webpack_public_path__ + "static/media/file_download.300fa380642cb2b013614aafc1ffebb4.svg";
export { ForwardRef as ReactComponent };